module.exports = __webpack_public_path__ + "joy-static/media/oval@3x.d7caf090.png";